import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./header.module.css";
import {
  faAngleLeft,
  faRightToBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useSidebarContext } from "../Context";
import { useEffect, useState } from "react";

const Header = () => {
  const { isSidebarCollapsed, toggleSidebar } = useSidebarContext();

  const logo = isSidebarCollapsed ? "/icon_logo_collapsed.svg" : "/newlogo.svg";

  return (
    <header
      className={`${styles.header} ${isSidebarCollapsed ? styles.close : ""}`}
      onClick={toggleSidebar}
    >
      <img src={logo} alt="Aaj Logo" className={styles.logo} />
      {/* {!isSidebarCollapsed && <FontAwesomeIcon icon={faRightToBracket} />} */}
    </header>
  );
};

export default Header;
